import React from 'react';
import { Check } from 'lucide-react';

/**
 * Top-of-modal progress indicator showing every step in the onboarding wizard
 * and marking the current/completed ones.
 */
const StepIndicators = ({ steps, currentStep }) => (
  <div className="onboarding-steps">
    {steps.map((step) => {
      const StepIcon = step.icon;
      const isActive = currentStep === step.id;
      const isDone = currentStep > step.id;
      return (
        <div
          key={step.id}
          className={`step-indicator ${isActive ? 'active' : ''} ${isDone ? 'completed' : ''}`}
        >
          <div className="step-icon">
            {isDone ? <Check size={14} /> : <StepIcon size={14} />}
          </div>
          <span className="step-title">{step.title}</span>
        </div>
      );
    })}
  </div>
);

export default StepIndicators;
